export const PhoneNumberValidator = {
  methods: {
    ValidateSLOMobileNumber (msisdn) {
      let denisSuperRegex = new RegExp('(?:0|386)(?:65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6})$')
      return denisSuperRegex.test(msisdn)
    },
    ValidateSLOFixNumber (msisdn) {
      let regex = new RegExp('^(?:0|386)(\\d{8})$')
      return regex.test(msisdn)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/GlobalnoTelefonija/PhoneNumberValidator.js